<template>
  <div class="comps-cardd-item">
    <div class="backimg centerimage gray-bg" @click="$emit('click')">
      <div :style="'background-image: url(' + imgurl + ');'"> <!-- 背景图 --> </div>
    </div>
    <div class="comps-cardd-content">
      <h2 class="to-2" @click="$emit('click')" v-if="title">{{title}}</h2>
      <h2 class="to-2" @click="$emit('click')" v-else>
        <span class="dis-bl ht-20 gray-bg mb-10"></span>
        <span class="dis-bl ht-20 gray-bg"></span>
      </h2>
      <p class="to-1" v-if="industries">行业: {{industries}}</p>
      <p class="to-1" v-else>
        <span class="dis-bl ht-18 gray-bg wi-180 mb-10"></span>
      </p>
      <p class="to-1" v-if="areas">业务: {{areas}}</p>
      <p class="to-2" v-else>
        <span class="dis-bl ht-18 gray-bg wi-180 mb-10"></span>
      </p>
      <p class="to-1" v-if="author">作者: {{author}}</p>
      <p class="to-1" v-else>
        <span class="dis-bl ht-18 gray-bg wi-100 mb-10"></span>
      </p>
      <p class="date" v-if="date">{{date.split(' ')[0]}}</p>
      <p class="date" v-else>
        <span class="dis-bl ht-18 gray-bg wi-100"></span>
      </p>
      <div class="btn">
        <span @click="$emit('click')">查看详情<a-icon type="right" /></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    imgurl: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    industries: {
      type: String,
      default: ''
    },
    areas: {
      type: String,
      default: ''
    },
    author: {
      type: String,
      default: ''
    },
    date: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  mounted () {
  }
}
</script>

<style lang="less" scoped>
@import url('../../../utils/color.less');
/* 小于等于 750 */
@media screen and (max-width: 751px) and (min-width: 300px) {
  @backimgWidth: 160px;
  @backimgHeight: 200px;
  .comps-cardd-item {
    padding-left: @backimgWidth;
    height: @backimgHeight;
    position: relative;
    .backimg {
      width: @backimgWidth;
      height: @backimgHeight;
      padding: 14px;
      background: @primarylight;
      position: absolute;
      left: 0;
      top: 0;
      div {
        width: 100%;
        height: 100%;
      }
    }
    .comps-cardd-content {
      padding-left: 20px;
      h2 {
        margin: 0 0 20px;
        font-family: Georgia, 宋体;
        font-weight: bold;
      }
      .to-2 {
        -webkit-line-clamp: 1;
      }
      p {
        margin: 0;
      }
      .date {
        margin-top: 20px;
      }
      .btn {
        font-size: 16px;
        color: @primary;
        margin-top: 20px;
      }
      .btn:hover {
        color: @support;
        cursor: pointer;
      }
    }
  }
  .comps-cardd-item:hover {
    cursor: default;
    h2 {
      cursor: pointer;
      color: @primary;
    }
  }
}
/* 大于 750 */
@media screen and (min-width: 751px) {
  @backimgWidth: 200px;
  @backimgHeight: 260px;
  .comps-cardd-item {
    padding-left: @backimgWidth;
    height: @backimgHeight;
    position: relative;
    .backimg {
      width: @backimgWidth;
      height: @backimgHeight;
      padding: 20px;
      background: @primarylight;
      position: absolute;
      left: 0;
      top: 0;
      div {
        width: 100%;
        height: 100%;
      }
    }
    .comps-cardd-content {
      padding-left: 20px;
      h2 {
        height: 63px;
        margin: 0 0 20px;
        font-family: Georgia, 宋体;
        font-weight: bold;
      }
      p {
        margin: 0;
      }
      .date {
        margin-top: 30px;
      }
      .btn {
        font-size: 16px;
        color: @primary;
        margin-top: 30px;
      }
      .btn:hover {
        color: @support;
        cursor: pointer;
      }
    }
  }
  .comps-cardd-item:hover {
    cursor: default;
    h2 {
      cursor: pointer;
      color: @primary;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Models/comps/cardPublication.vue